module.exports = __webpack_public_path__ + "img/logo-white.b677ca17.png";